export const initializePendo = (user) => {
    if (process.env.MIX_DISABLE_PENDO) {
        return;
    }

    // eslint-disable-next-line no-undef
    pendo.initialize({
        visitor: {
            id: user.id,
            email: user.email,
            firstName: user.firstname,
            lastName: user.lastname,
            language: user.locale,
        },
    });
};
